<template>
  <div class="containerBox" ref="box">
    <!--  顶部导航  -->
    <nav-bar />
    <!--  轮播图  -->
    <banner-list :banner-list="bannerList" />
    <!--  从发货到结算  -->
    <div class="box1" v-scroll-reveal>
      <div class="container dis">
        <div class="box1_left">
          <div class="box1_left_title">从发货到结算，我们全程服务</div>
          <div class="box1_left_sub_title">Full service</div>
          <p>为您提供值得相信的服务平台:</p>
          <p>我们建立严格的审核机制保证平台的运行安全，同时建立运力准入机制并实时监控货物状态。确保订单安全交付</p>
        </div>
        <div class="box1_right">
          <!--     最底层光圈       -->
          <img class="box1_right_bg" :style="`transform: rotate(${selectIndex * 72}deg)`" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/fullServe_bg.png" alt="">
          <!--     底层轮播照片       -->
          <div class="posImg" v-for="(item, index) in serveData" :key="index" :style="{left: item.left, top: item.top}" @mouseenter="posChange(index)" @mouseleave="resetTime">
            <img :src="selectIndex === index ? item.imgSrc1 : item.imgSrc" alt="">
            <!--  <img class="posImg2" :src="item.imgSrc1" alt="">  -->
          </div>
          <div class="posImg_center">
            <img :src="serveData[selectIndex].imgSrc2" alt="">
          </div>
        </div>
      </div>

    </div>
    <!--  卡片信息  -->
    <div class="card">
      <div class="container">
        <div class="card_box" v-scroll-reveal>
          <div class="card_box_item">
            <img class="card_box_item_img" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/card1.png" alt="">
            <div class="card_box_item_box">
              <div class="card_box_item_box_left">
                <span class="card_box_item_box_left_bg">01</span>
                <p>高效的运输</p>
              </div>
              <div class="card_box_item_box_right">
                <div class="card_box_item_box_right_item" style="margin-top: 20px;">
                  <div class="card_box_item_box_right_item_left"></div>
                  <div class="card_box_item_box_right_item_right">多车多线路的实时调度算法</div>
                </div>
                <div class="card_box_item_box_right_item">
                  <div class="card_box_item_box_right_item_left"></div>
                  <div class="card_box_item_box_right_item_right">无固定装卸货地的全局效率更优</div>
                </div>
                <div class="card_box_item_box_right_item">
                  <div class="card_box_item_box_right_item_left"></div>
                  <div class="card_box_item_box_right_item_right">多类型车辆的协同调度</div>
                </div>
              </div>
            </div>
          </div>
          <div class="card_box_item">
            <img class="card_box_item_img" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/card2.png" alt="">
            <div class="card_box_item_box">
              <div class="card_box_item_box_left">
                <span class="card_box_item_box_left_bg">02</span>
                <p>透明的价格</p>
              </div>
              <div class="card_box_item_box_right">
                <div class="card_box_item_box_right_item" style="margin-top: 20px;">
                  <div class="card_box_item_box_right_item_left"></div>
                  <div class="card_box_item_box_right_item_right">机器学习</div>
                </div>
                <div class="card_box_item_box_right_item">
                  <div class="card_box_item_box_right_item_left"></div>
                  <div class="card_box_item_box_right_item_right">供需预测</div>
                </div>
              </div>
            </div>
          </div>
          <div class="card_box_item">
            <img class="card_box_item_img" src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/card3.png" alt="">
            <div class="card_box_item_box">
              <div class="card_box_item_box_left">
                <span class="card_box_item_box_left_bg">03</span>
                <p>可靠的服务</p>
              </div>
              <div class="card_box_item_box_right">
                <div class="card_box_item_box_right_item" style="margin-top: 20px;">
                  <div class="card_box_item_box_right_item_left"></div>
                  <div class="card_box_item_box_right_item_right">智能管控</div>
                </div>
                <div class="card_box_item_box_right_item">
                  <div class="card_box_item_box_right_item_left"></div>
                  <div class="card_box_item_box_right_item_right">运力准入体系</div>
                </div>
                <div class="card_box_item_box_right_item">
                  <div class="card_box_item_box_right_item_left"></div>
                  <div class="card_box_item_box_right_item_right">任务型多轮调配</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--   页面展示 -->
    <page-display :qrCodeData="qrCodeData" :navData="navData"  typeTitle="货主端"/>
    <!--  底部  -->
    <bottom-footer/>
    <!--  悬浮按钮  -->
    <fix-anchor @goBottom="goBottom" />
  </div>
</template>

<script>
import NavBar from '@/components/nav-bar.vue'
import BannerList from '@/components/banner-list.vue'
import BottomFooter from '@/components/bottom-footer.vue'
import FixAnchor from '@/components/fix-anchor.vue'
import PageDisplay from '@/components/page-display.vue'
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: "ServeShipper",
  components: {
    NavBar,
    BannerList,
    BottomFooter,
    FixAnchor,
    PageDisplay
  },
  data() {
    return{
      bannerList: ['https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/banner/serve_shiper_banner.png'],
      Timer: null,
      selectIndex: 0,
      qrCodeData: [
        {
          id: 1,
          title: 'iOS版',
          icon2: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/ios.png',
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/ios2.png',
          url: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/i_hz4.png'
        },
        {
          id: 2,
          title: 'Android版',
          icon2: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/android.png',
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/android2.png',
          url: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/a_hz.png'
        },
        {
          id: 3,
          title: '小程序',
          icon2: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/mini2.png',
          icon: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/mini.png',
          url: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/aboutus/wxminCode.jpg'
        },
      ],
      navData: [
        {
          title: '发布货源',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/display_fh.png'
        },
        {
          title: '接单弹窗提示',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/display_jd.png'
        },
        {
          title: '轨迹页面',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/display_gj.png'
        },
        {
          title: '钱包',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/display_qb.png'
        },
        {
          title: '我的',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/display_wd.png'
        },
        {
          title: '积分',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/display_jf.png'
        },
      ],
      serveData: [
        {
          id: 0,
          title: '发货',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/fahuo.png',
          imgSrc1: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/fahuo_1.png',
          imgSrc2: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/fahuo_bg.png',
          left: '-25px',
          top: '249px',
        },
        {
          id: 1,
          title: '装货',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/zhuanghuo.png',
          imgSrc1: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/zhuanghuo_1.png',
          imgSrc2: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/zhuanghuo_bg.png',
          left: '203px',
          top: '-15px',
        },
        {
          id: 2,
          title: '运输',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/yunshu.png',
          imgSrc1: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/yunshu_1.png',
          imgSrc2: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/yunshu_bg.png',
          left: '492px',
          top: '116px',
        },
        {
          id: 3,
          title: '卸货',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/xiehuo.png',
          imgSrc1: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/xiehuo_1.png',
          imgSrc2: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/xiehuo_bg.png',
          left: '465px',
          top: '433px',
        },
        {
          id: 4,
          title: '结算',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/jiesuan.png',
          imgSrc1: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/jiesuan_1.png',
          imgSrc2: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/serve/jiesuan_bg.png',
          left: '155px',
          top: '505px',
        },
      ]
    }
  },
  created(){
    this.resetTime()
  },
  methods: {
    /**
     * @description: 鼠标划入到圆圈中
     * @author: 书童
     */
    posChange(e){
      clearInterval(this.Timer)
      this.selectIndex = e
    },
    /**
     * @description: 页面滚动到顶部
     * @author: 书童
     */
    goBottom() {
      let top = this.$refs.box.offsetHeight, scrollTop = document.body.scrollTop, clientHeight = document.documentElement.clientHeight
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = scrollTop += 50
        if (top <= (scrollTop + clientHeight)) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    /**
     * @description: 开始计时器
     * @author: 书童
     */
    resetTime() {
      this.Timer = setInterval(() => {
        if (this.selectIndex <= 3) {
          this.selectIndex++
        } else {
          this.selectIndex = 0
        }
      }, 1500)
    }
  }
}
</script>

<style scoped lang="scss">
.dis{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 1200px;
}
.box1{
  overflow: hidden;
  width: 100%;
  height: 715px;
  background-color: #fff;
  .box1_left{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 528px;
    height: 715px;
    .box1_left_title{
      font-size: 30px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: left;
      color: #333333;
      line-height: 42px;
    }
    .box1_left_sub_title{
      font-size: 70px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: LEFT;
      color: #e0e0e0;
      line-height: 98px;
      margin-top: 20px;
      margin-bottom: 44px;
    }
    &>p{
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #666666;
      line-height: 21px;
    }
  }
  .box1_right{
    position: relative;
    width: 558px;
    height: 559px;
    //background-color: red;
    .box1_right_bg{
      position: absolute;
      left: 0;
      top: 0;
      height: 559px;
      width: 558px;
      z-index: 1;
    }
    .posImg{
      position: absolute;
      width: 56px;
      height: 56px;
      // background-color: #fff;
      // border-radius: 50%;
      z-index: 2;
      img{
        display: block;
        width: 100%;
        height: 100%;
      }
      .posImg1{
        display: block;
      }
      .posImg2{
        display: none;
      }
    }
    .posImg:hover{
      .posImg1{
        display: none;
      }
      .posImg2{
        display: block;
      }
    }
    .posImg_center{
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      height: 435px;
      width: 436px;
      box-shadow: 0px 4px 40px 0px rgba(0,111,255,0.10);
      z-index: 3;
      border-radius: 50%;
      &>img{
        display: block;
        height: 435px;
        width: 436px;
      }
    }
  }
}
.card{
  height: 630px;
  width: 100%;
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/card_bg.png') no-repeat;
  background-size: 1750px 404px;
  background-position: 170px 226px;
  .card_box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 442px;
    .card_box_item{
      overflow: hidden;
      width: 380px;
      height: 422px;
      background: #ffffff;
      border-radius: 30px;
      transform: scale(1);
      transition: transform 0.6s;
      .card_box_item_img{
        width: 100%;
        height: 300px;
      }
      .card_box_item_box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 121px;
        padding: 0 15px;
        box-sizing: border-box;
        .card_box_item_box_left{
          position: relative;
          width: 120px;
          height: 121px;
          p{
            position: relative;
            font-size: 18px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: center;
            color: #333333;
            line-height: 121px;
            z-index: 2;
          }
          .card_box_item_box_left_bg{
            position: absolute;
            left: 0;
            right: 0;
            top: -10px;
            bottom: 0;
            font-size: 100px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            color: #ececec;
          }
        }
        .card_box_item_box_right{
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          margin-left: 15px;
          .card_box_item_box_right_item{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 20px;
            margin-top: 10px;
            .card_box_item_box_right_item_left{
              width: 8px;
              height: 8px;
              background: #4e9bff;
              border-radius: 50%;
              margin-right: 10px;
            }
            .card_box_item_box_right_item_right{
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              text-align: LEFT;
              color: #666666;
              line-height: 20px;
            }
          }
        }
      }
    }
    .card_box_item:hover{
      transform: scale(1.1);
      transition: transform 0.6s;
      /*width: 400px;
      height: 442px;
      .card_box_item_img{
        width: 100%;
        height: 320px;
      }*/
    }
  }
}


</style>